import { render, staticRenderFns } from "./SplitTestSetting.vue?vue&type=template&id=53790449"
import script from "./SplitTestSetting.vue?vue&type=script&lang=js"
export * from "./SplitTestSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports